import { Grid } from '@material-ui/core';
import * as React from 'react';

import { IAgencyTeamMember } from '../../store/models';

interface IProps {
    member: IAgencyTeamMember;
}

export const TeamMember: React.FC<IProps> = ({ member: { name, photo, position } }) => (
    <Grid item xs={12} sm={6} md={4}>
        <div className="member">
            <div className="member__image">
                <img src={photo} alt="" />
            </div>
            <div className="member__name">
                <h3>{name}</h3>
            </div>
            <div className="member__position">
                <p>{position}</p>
            </div>
        </div>
    </Grid>
);
